import { faChalkboard } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { ButtonLink, Icon } from '~/ui-components';

export const NewCourseButton = () => {
   const { _js } = useLocalization();

   return (
      <ButtonLink
         variant="solid"
         colorScheme="blue"
         href="/Courses/New"
         leftIcon={<Icon type={faChalkboard} />}
      >
         {_js('New Course')}
      </ButtonLink>
   );
};
